<template>
  <div class="cmp-distribution-dashboard-category dt-page">
    <NTable :id="'distribution-dashboard-category'" :headers="headers" :items="items" class="h1"
      :config="topTracksTableConfig">
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-for="header in headers" :key="header.value" v-bind="tdcon(header.value)">
      
              <div v-if="header.value == 'category'" style="display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.3rem;">
                <div style="width: 10px;
                   height: 10px; border-radius: 50px;" :style="{
      backgroundColor: `${item.color}`,
    }"></div>
                <span :title="item[header.value]">{{$dft.capHead($t(item[header.value]))  }}</span>
              </div>
              <span style="color:#282828;font-weight:600" v-else-if="header.value=='total'" :title="numberWithCommas(item[header.value])" >{{ numberWithCommas(item[header.value]) }}</span>
              <span v-else :title="numberWithCommas(item[header.value])" >{{ numberWithCommas(item[header.value]) }}</span>
         

          </td>

        </tr>
      </template>
      <template v-slot:tfoot="{ thcon }">
        <tr>
          <td v-for="header in headers" :key="header.value" v-bind="thcon(header.value)">
            <span style="color:#828282;" v-if="header.value == 'category'" :title="numberWithCommas(getTotal(header.value))" :style="{
      textAlign: header.ta || 'left',
    }" >{{ $t('total') }}</span>
                  <span v-else :title="getTotal(header.value)" :style="{
      textAlign: header.ta || 'left',
    }" style="color:#282828;font-weight:600">{{numberWithCommas(getTotal(header.value))
              }}</span>
          </td>
        </tr>
      </template>
    </NTable>

  </div>
</template>




<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
    NTable,
  },
  props: {
    items: {
      type: Array,
      default:[]   
    },
    headers: {
      type: Array,
    },
    default_currency: {
      type: String,
    },
  },
  data() {
    return {
      topTracksTableConfig: createNTableConfig({
        scrollNextThreshold: 95,
        footer: true
      }),
    };
  },

  computed: {
  },
  methods: {
    numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    getTotal(columnName) {
      if (columnName == 'category') {
        return '';
      }
      return this.items && this.items.map(t => {
        return t[columnName] ? t[columnName] : 0
      }).reduce((acc, value) => acc + value, 0);
    }
  },
};
</script>

<style lang="scss">
.cmp-distribution-dashboard-category {
  height: 100vh;
  margin: 0px 20px 0px 10px;
  .dt-ntable.distribution-dashboard-category {
    --ntable-height: 100% !important;
    td {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

   
  }
  .dt-ntable tfoot, .dt-ntable tfoot tr{
      cursor: pointer
    }
  .dt-ntable {
    width: 100%;
    min-width: 100%;
   
  }
  .dt-ntable tbody  {
   height: fit-content;
  }
  .dt-ntable tbody tr:last-child {
    border-bottom: 1px solid black;
  }
  .dt-ntable td > div:not(.dt-icon-container):not(.fc2):not(.dbox1){
    margin:0px
  }
  .dt-ntable th>div,
  .dt-ntable th>span,
  .dt-ntable td>span {
    margin: 0 !important
  }
}
</style>